import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { AuthProvider } from './context/AuthContext';
import { FiltersProvider } from './context/FiltersContext';
import { ThemeProvider } from './context/ThemeContext';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from './ui/Toast';
import { BackLayerProvider } from './context/BackLayerProvider';
import MutationErrorToasts from './components/MutationErrorToasts';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <FiltersProvider>
            <BrowserRouter>
              <BackLayerProvider>
                <ToastProvider>
                  <MutationErrorToasts />
                  <App />
                </ToastProvider>
              </BackLayerProvider>
            </BrowserRouter>
          </FiltersProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
